import { getToken, removeToken } from "@/utils/auth";
import { setStore, getStore } from "@/utils/store";
const user = {
  state: {
    userInfo: getStore({
      name: "userInfo"
    }) || {},
  },
  mutations: {
    SET_USERIFNO: (state, userInfo) => {
      state.userInfo = userInfo;
      setStore({
        name: "userInfo",
        content: state.userInfo
      });
    },
  },
  actions: {
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_USERIFNO", {})
        removeToken()
        resolve()
      });
    },
  },
};
export default user;
